export const RainSleetIcon = () => (
    <svg
        tabIndex={-1}
        focusable="false"
        className="svg-icon icon-weather"
        width="80px"
        height="80px"
        fill="none"
        viewBox="0 0 80 80"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g className="weather-fill" id="06" fill="#3F4447">
                <g transform="translate(2.000000, 10.000000)">
                    <path
                        d="M64.582 52.68c4.969 0 8.986-3.954 8.986-8.82 0-4.867-4.017-8.822-8.986-8.822a9.16 9.16 0 00-2.332.3 1.55 1.55 0 01-1.93-1.292c-.586-4.351-4.383-7.65-8.907-7.65-.105 0-.211.001-.316.005a1.55 1.55 0 01-1.567-1.22c-1.477-6.801-7.62-11.75-14.797-11.75-7.777 0-14.26 5.792-15.051 13.327a1.55 1.55 0 01-1.457 1.385c-6.604.36-11.793 5.74-11.793 12.26 0 6.775 5.59 12.278 12.498 12.278h45.652zm0-20.74c6.669 0 12.085 5.33 12.085 11.92 0 6.588-5.416 11.92-12.085 11.92H18.93c-8.608 0-15.596-6.88-15.596-15.378 0-7.749 5.826-14.196 13.445-15.232 1.512-8.49 9.034-14.837 17.954-14.837 8.209 0 15.306 5.391 17.521 12.992 5.143.35 9.46 3.889 10.808 8.708a12.348 12.348 0 011.52-.094z"
                        fill="#717277"
                    />
                    <path
                        d="M43.65 64.13a1.55 1.55 0 00-2.19-2.19l-5.113 5.112a1.55 1.55 0 002.191 2.191l5.113-5.112zM64.308 64.13a1.55 1.55 0 00-2.19-2.19l-5.113 5.112a1.55 1.55 0 102.191 2.191l5.112-5.112z"
                        fill="#9ADAFF"
                    />
                    <path
                        d="M18.31 70.24a4.648 4.648 0 110-9.297 4.648 4.648 0 010 9.296zm0-3.1a1.55 1.55 0 100-3.098 1.55 1.55 0 000 3.099z"
                        fill="#717277"
                    />
                </g>
            </g>
        </g>
    </svg>
);
